import axios, { AxiosResponse } from 'axios';

import Config from '../../../config';
import { ReportTypeUrlMapping } from '../../../helpers/report-helpers/constants';

import { DataTypesResponse, ReportParam, BusinessHistoryResponseDto } from './report.state';

import { ReportViewType } from 'types';

class ReportService {
  public async getReport(
    { type, params, reportView }: ReportParam,
    signal?: AbortSignal,
  ): Promise<any> {
    let urlString = `${Config.FEEDER_SERVER}/${ReportTypeUrlMapping[type]}`;
    if (reportView === ReportViewType.REPORT) urlString += '/report';
    return axios.get(urlString, { params, signal });
  }

  public async getDataTypes(): Promise<AxiosResponse<DataTypesResponse[]>> {
    return axios.get<DataTypesResponse[]>(
      `${Config.FEEDER_SERVER}/v2/data/dataTypes?isExtended=true`,
    );
  }

  public async getBusinessHistoryBusiness({
    params,
  }): Promise<AxiosResponse<BusinessHistoryResponseDto>> {
    return axios.get<BusinessHistoryResponseDto>(
      `${Config.FEEDER_SERVER}/v2/businesses/connectionHistory/${params.uuid}`,
    );
  }

  public async getByodUploadFiles({ params }): Promise<AxiosResponse<any>> {
    return axios.get(`${Config.FEEDER_SERVER}/v2/data/pushStatus`, { params });
  }
}

export default new ReportService();
